<div id="watch-orders-container">
  <div
    id="watch-orders-grid"
    #watchOrdersGrid
    [ngClass]="{ 'disabled-grid': loading }"
  >
    <ag-grid-angular
      [rowData]="orders"
      class="ag-theme-cdx"
      [gridOptions]="gridOptions"
      [animateRows]="true"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged()"
    ></ag-grid-angular>
  </div>
</div>
